import { render, staticRenderFns } from "./Investir.vue?vue&type=template&id=975464c6&"
import script from "./Investir.vue?vue&type=script&lang=js&"
export * from "./Investir.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports